import React, { memo, useCallback, useState, useEffect } from 'react';

import { useDrop } from 'react-dnd';
import { MenuCard } from './MenuCard';
import update from 'immutability-helper';
import NEXUS_CONST from '../../common/constants';
import * as utils from '../../common/utils';
import _ from 'lodash'

const style = {
    //width: 400,
};


const Container = memo(function Container({ template, saveCard, deleteCard, updateActiveItem, updateTemplate, setVisibility, cloneItem, activeMenu}) {
    const [cards, setCards] = useState(template);
    const queryProps = utils.getUrlQueryData()
    const activeTab = queryProps.tab ? queryProps.tab : '';
    let tabVal = 0;
    if (activeTab) {
        let menuVal = template.findIndex(d => d.id == activeTab)
        tabVal = menuVal > -1 ? menuVal : 0
    }
    const [activeItem, setActiveItem] = useState(tabVal);
    const [editActive, setEditActive] = useState(null);


    const findCard = useCallback((id) => {
        const card = cards.filter((c) => `${c.id}` === id)[0];
        return {
            card,
            index: cards.indexOf(card),
        };
    }, [cards]);
    const moveCard = useCallback((id, atIndex) => {
        const { card, index } = findCard(id);
        let data = update(cards, {
            $splice: [
                [index, 1],
                [atIndex, 0, card],
            ],
        })
        setCards(data);
        updateTemplate(data)
    }, [findCard, cards, setCards]);
     const [, drop] = useDrop(() => ({ accept: NEXUS_CONST.DND_TYPES.MENU_CARD }));

    const updateActive = (i) => { setActiveItem(i); updateActiveItem(i) };
 
    useEffect(()=>{ setCards(template) }, [template])

    

    return (<ul ref={drop} style={style} className="scroll" >

        {cards.map((card, i) => (<MenuCard
            key={card.id}
            id={`${card.id}`}
            title={card.title}
            iconCls={card.iconCls}
            isActive={i === activeMenu}
            moveCard={moveCard}
            findCard={findCard}
            deleteCard={deleteCard}
            saveCard={saveCard}
            setActiveItem={updateActive}
            index={i}
            visible={card.isActive}
            setVisibility={setVisibility}
            cloneItem={cloneItem}
            updateEditActive={(i) => setEditActive(i)}
            editActive={editActive}

         
        />))}

    </ul>);
});
export default Container